// SIZES & QUERIES

export const sizesValues = {
	xsm: 360,
	sm: 479,
	smd: 534,
	md: 768,
	lmd: 991,
	lg: 1024,
	xl: 1199,
	xxl: 1439,
	xxxl: 1699,
	maxl: 1920,
};

/*
export const sizes = {
	xsm: "360px",
	sm: "479px",
	smd: "534px",
	md: "768px",
	lmd: "991px",
	lg: "1024px",
	xl: "1199px",
	xxl: "1439px",
	xxxl: "1699px",
	maxl: "1920px",
};

export const mediaQueryMin = {
	xsm: `(min-width: ${sizes.xsm})`,
	sm: `(min-width: ${sizes.sm})`,
	smd: `(min-width: ${sizes.smd})`,
	md: `(min-width: ${sizes.md})`,
	lmd: `(min-width: ${sizes.lmd})`,
	lg: `(min-width: ${sizes.lg})`,
	xl: `(min-width: ${sizes.xl})`,
	xxl: `(min-width: ${sizes.xxl})`,
	xxxl: `(min-width: ${sizes.xxxl})`,
	maxl: `(min-width: ${sizes.maxl})`,
};

export const mediaQueryMax = {
	xsm: `(max-width: ${sizes.xsm})`,
	sm: `(max-width: ${sizes.sm})`,
	smd: `(max-width: ${sizes.smd})`,
	md: `(max-width: ${sizes.md})`,
	lmd: `(max-width: ${sizes.lmd})`,
	lg: `(max-width: ${sizes.lg})`,
	xl: `(max-width: ${sizes.xl})`,
	xxl: `(max-width: ${sizes.xxl})`,
	xxxl: `(max-width: ${sizes.xxxl})`,
	maxl: `(max-width: ${sizes.maxl})`,
};
 */
